import React, { useContext, useRef, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { Link, useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import validator from 'validator';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
import moment from 'moment-timezone';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LoginGoogle } from '../login-with-social-media/login-google';
import { GoogleOAuthProvider } from '@react-oauth/google';
import useIsGuest from '../../../components/Hook/useIsGuest';
import { urlConfig } from '../../../config/urlConfig';
import LoginWithFacebook from '../login-with-social-media/LoginWithFacebook';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.ui.secondary,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  passwordContainer: {
    margin: 0,
  },
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  caption: {
    color: '#f44336',
  },
  signup_footer: {
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  wrapper: {
    margin: '10px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  other: {
    color: '#757575',
    fontWeight: 700,
    width: '100%',
    display: 'block',
    padding: '0.1px ',
    height: '100%',
    backgroundColor: '#7575752e',
  },
  otherText: {
    color: '#757575',
    margin: '0 6px',
    fontWeight: 500,
  },
  continue: {
    display: 'block',
    margin: '12px auto',
    color: '#757575',
  },
  singinText: {
    color: '#757575',
  },
}));

const time_zones_list = moment.tz.names();
const local_time_zone = moment.tz.guess();

export default function SignUp() {
  useIsGuest();
  const [timeZone, setTimeZone] = useState(local_time_zone);
  const { setUserData, setUserPreferTime } = useContext(
    AuthenticationContext
  );
  const classes = useStyles();
  const history = useHistory();
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const usernameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState(false);
  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState(false);
  const [userNameExist, setUserNameExist] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');

  const submitHandler = (e) => {
    e.preventDefault();
    setUserData(null);
    setUserPreferTime(null);
    setFirstNameError(false);
    setLastNameError(false);
    setUsernameError(false);
    setEmailError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);

    if (validator.isEmpty(firstName)) {
      setFirstNameError(true);
      firstNameRef.current.focus();
    }
    if (validator.isEmpty(lastName)) {
      setLastNameError(true);
      if (firstName !== '') {
        lastNameRef.current.focus();
      }
    }
    if (validator.isEmpty(username)) {
      setUsernameError(true);
      if (firstName && lastName !== '') {
        usernameRef.current.focus();
      }
    } else {
      setUserNameExist('');
      setUsernameError(false);
    }

    if (validator.isEmpty(email)) {
      setEmailError(true);
      if (firstName && lastName && username !== '') {
        emailRef.current.focus();
      }
    }

    if (validator.isEmpty(password)) {
      setPasswordError(true);
      if (firstName && lastName && username && email !== '') {
        if (validator.isEmail(email)) {
          passwordRef.current.focus();
        }
      }
    }

    if (validator.isEmpty(confirmPassword)) {
      setConfirmPasswordError(true);
      if (firstName && lastName && username && email && password !== '') {
        confirmPasswordRef.current.focus();
      }
    }

    if (password && confirmPassword) {
      if (password !== confirmPassword) {
        setFormError(`The two password fields didn't match.`);
        return false;
      }

      if (password.length < 8) {
        setFormError(
          'This password is too short. It must contain at least 8 characters.This password is too common.'
        );
        return false;
      }
    }

    const data = {
      first_name: firstName.toLowerCase(),
      last_name: lastName.toLowerCase(),
      username: username.toLowerCase(),
      email: email.toLowerCase(),
      password1: password,
      password2: confirmPassword,
    };

    if (
      firstName &&
      lastName &&
      username &&
      email &&
      !emailError &&
      password &&
      confirmPassword
    ) {
      setLoading(true);
      axios
        .post(urlConfig.register_url, data)
        .then((res) => {
          localStorage.clear();
          setLoading(false);
          history.push('/signup/confirm');
        })
        .catch((err) => {
          setLoading(false);
          setFormError('');
          if (err.response) {
            if (err.response.status && err.response.status === 500) {
              setFormError('Request failed');
            } else if (err.response.data.password1) {
              setFormError(err.response.data.password1);
            } else if (err.response.data.non_field_errors) {
              setFormError(err.response.data.non_field_errors);
            } else if (err.response.non_field_errors) {
              setFormError(err.response.non_field_errors);
            } else {
              setFormError('');
            }

            err.response.data.username
              ? setUserNameExist(err.response.data.username)
              : setUserNameExist('');
            err.response.data.email && setFormError(err.response.data.email);
          }
          if (err.message === 'Network Error') {
            setFormError(err.message);
          }
        });
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Sign up
        </Typography>
        <form
          className={classes.form}
          noValidate
          autoComplete='off'
          onSubmit={submitHandler}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                size='small'
                name='firstName'
                variant='outlined'
                fullWidth
                id='firstName'
                label='First Name'
                error={firstNameError}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  setFirstNameError(false);
                }}
                inputRef={firstNameRef}
                autoFocus
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size='small'
                variant='outlined'
                fullWidth
                id='lastName'
                label='Last Name'
                name='lastName'
                inputRef={lastNameRef}
                error={lastNameError}
                onChange={(e) => {
                  setLastName(e.target.value);
                  setLastNameError(false);
                }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size='small'
                variant='outlined'
                fullWidth
                id='username'
                label='Username'
                autoComplete='username'
                name='username'
                inputRef={usernameRef}
                error={usernameError}
                helperText={
                  <Typography variant='caption' color='error'>
                    {userNameExist}
                  </Typography>
                }
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUsernameError(false);
                }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size='small'
                variant='outlined'
                fullWidth
                id='email'
                label='Email Address'
                name='email'
                inputRef={emailRef}
                error={emailError}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError(false);
                }}
                required
              />
            </Grid>

            <Grid
              container
              spacing={2}
              className={classes.passwordContainer}
              xs={12}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  size='small'
                  variant='outlined'
                  fullWidth
                  name='password'
                  label='Password'
                  type='password'
                  autoComplete='new-password'
                  inputRef={passwordRef}
                  error={passwordError}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError(false);
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  size='small'
                  variant='outlined'
                  fullWidth
                  label='Confirm'
                  type='password'
                  autoComplete='new-password'
                  inputRef={confirmPasswordRef}
                  name='confirmPassword'
                  id='confirmPassword'
                  error={confirmPasswordError}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setConfirmPasswordError(false);
                  }}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                {/* <Autocomplete
                  value={timeZone}
                  disableClearable
                  onChange={(event, value) => {
                    setTimeZone(value);
                  }}
                  options={time_zones_list}
                  size='small'
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      label='Time zone'
                      variant='outlined'
                    />
                  )}
                  required
                /> */}

                {formError && (
                  <Grid className={classes.caption}>
                    <Typography variant='caption' color='error'>
                      {formError}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography variant='subtitle2' color='textSecondary'>
              By signing up, I agree to the Mizbans's
              <Link to='/privacy' className={classes.link}>
                Privacy Statement
              </Link>
              and
              <Link to='/terms' className={classes.link}>
                Terms of Service
              </Link>
              .
            </Typography>
          </Grid>

          <Box mt={4} className={classes.wrapper}>
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              disabled={loading}
              name='signUp'
              id='signUp'
            >
              Sign Up
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Box>
          <Grid container className={classes.signup_footer}>
            <Grid xs={12} item className={classes.signin}>
              <Typography variant='caption' className={classes.singinText}>
                Already have an account?
                <Link to='/signin' className={classes.link}>
                  Sign in
                </Link>
              </Typography>
              <Box item display='flex' alignItems='center' m={2}>
                <span className={classes.other}></span>
                <Typography variant='caption' className={classes.otherText}>
                  Or
                </Typography>
                <span className={classes.other}></span>
              </Box>
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='center'
                mr='auto'
                ml='auto'
                width={270}
              >
                <GoogleOAuthProvider clientId={urlConfig.GOOGLE_API}>
                  <LoginGoogle setFormError={setFormError} />
                </GoogleOAuthProvider>
                {/* <LoginWithTwitter setFormError={setFormError} /> */}
                {/* <LoginWithFacebook setFormError={setFormError} /> */}
              </Box>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}
